import { Search } from 'lucide-react';
import { useId } from 'react';
import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
    /** Appelée à la validation (Entrée) avec le texte saisi, sans espaces autour. */
    onSearch?: (query: string) => void;
    className?: string;
}

/** Champ de recherche du header : la logique de recherche est fournie par la page via onSearch. */
export default function SearchBar({ onSearch, className }: SearchBarProps) {
    const { t } = useTranslation();
    const inputId = useId();

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const query = new FormData(event.currentTarget).get('q');
        onSearch?.(typeof query === 'string' ? query.trim() : '');
    };

    return (
        <form role="search" onSubmit={handleSubmit} className={className}>
            <label htmlFor={inputId} className="sr-only">
                {t('layout.search.label')}
            </label>
            <div className="relative">
                <Search
                    aria-hidden="true"
                    className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-gray-500 dark:text-gray-400"
                />
                <input
                    id={inputId}
                    name="q"
                    type="search"
                    placeholder={t('layout.search.placeholder')}
                    className="w-full rounded-full border border-gray-300 bg-white py-2 pl-9 pr-4 text-sm text-gray-900 placeholder:text-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:placeholder:text-gray-400 dark:focus-visible:outline-white"
                />
            </div>
        </form>
    );
}
